var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{staticClass:"mt-4"},[_c('b-checkbox',{model:{value:(_vm.form.agreed),callback:function ($$v) {_vm.$set(_vm.form, "agreed", $$v)},expression:"form.agreed"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('legal.privacyAgreed', _vm.links))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }